import { useEffect, useState } from "react"
import { customerData, CustomerPlaidAgreement, PlaidAuthorization } from "../../../utilities/CustomerData"
import { refreshAccessToken } from "../../../utilities/extensions"
import { apiURL } from "../../../utilities/URLs"
import { useNavigate } from "react-router-dom"

export function PlaidConfirmModal({ _plaidAuthorization, paymentAmount, handleAgreement, clientSignature, currentDate, setShowPlaidConfirmModal }) {
  const plaidAuthorization = new PlaidAuthorization(_plaidAuthorization)
  const navigate = useNavigate()

  const [userIP, setUserIP] = useState('')
  const [uploadingAgreement, setUploadingAgreement] = useState(false)

  useEffect(() => {
    const handleGetUserIP = async () => {
      const userIPResponse = await fetch('https://api.ipify.org?format=json')
      const userIPData = await userIPResponse.json()
      setUserIP(userIPData.ip ? userIPData.ip : '')
    }

    handleGetUserIP()
  }, [])

  const handleUploadAgreement = async () => {
    setUploadingAgreement(true)

    const form = new FormData()
    form.append('plaidAgreementInfo', JSON.stringify({
      leadId: customerData.customerLeadData.leadId,
      customerId: customerData.customerLeadData.leadContact.contactId,
      customerIP: userIP,
      customerSignature: clientSignature,
      customerName: customerData.customerLeadData.leadContact.contactName,
      customerEmail: customerData.customerLeadData.leadContact.contactEmail,
      customerPhone: customerData.customerLeadData.leadContact.contactPhone,
      currentDate: currentDate,
      paymentAmount: customerData.customerInvoiceData.invoiceRemainingBalance,
      plaidAuthorization: plaidAuthorization
    }))

    const uploadPlaidAgreementResponse = await fetch(`${apiURL}/api/uploadPlaidAgreement`, {
      method: 'POST',
      headers: {
        'Authorization': customerData.accessToken
      },
      body: form
    })
    const uploadPlaidAgreementData = await uploadPlaidAgreementResponse.json()
    setUploadingAgreement(false)

    if (uploadPlaidAgreementData.response.error) {
      if (uploadPlaidAgreementData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleUploadAgreement() : navigate('/', { state: { expired: true } })
      } else
        console.error(uploadPlaidAgreementData.response.error)
    } else {
      customerData.customerPlaidAgreement = new CustomerPlaidAgreement(uploadPlaidAgreementData.response.customerPlaidAgreement)
      handleAgreement()
      setShowPlaidConfirmModal(false)
    }
  }

  return (
    <div className='fixed z-50 flex justify-center items-center top-0 left-0 w-full h-full bg-gray-900 bg-opacity-70'>
      <div className='relative flex flex-col lg:w-1/3 w-11/12 p-6 bg-white rounded-lg shadow-xl'>
        <div className='flex flex-row w-full gap-4'>
          <div className='w-full border border-gray-200 rounded-lg p-4 bg-gray-50 divide-y divide-gray-200 flex flex-col'>
            <div className='flex-1 px-4 py-2 flex flex-col justify-center'>
              <p className='text-xs font-semibold text-gray-500'>Payment Amount</p>
              <p className='text-2xl font-bold text-gray-900 mt-1'>${Number(Number(paymentAmount).toFixed(2)).toLocaleString()}</p>
            </div>
            <div className='flex-1 px-4 py-2 flex flex-col justify-center'>
              <p className='text-xs font-semibold text-gray-500'>Company</p>
              <p className='text-lg text-gray-900 mt-1'>SETC Pros Inc.</p>
            </div>
            <div className='flex-1 px-4 py-2 flex flex-col justify-center'>
              <p className='text-xs font-semibold text-gray-500'>Bank Information</p>
              <p className='text-lg font-medium text-gray-900 mt-1'>{plaidAuthorization.bankInfo.accountInfo.accountName}</p>
              <p className='text-sm text-gray-600'>Account ending in: **** {plaidAuthorization.bankInfo.accountInfo.accountNumberMask}</p>
            </div>
            <div className='flex-1 px-4 py-2 flex flex-col justify-center'>
              <p className='text-lg font-semibold'>ACH Debit</p>
            </div>
            <button
              onClick={handleUploadAgreement}
              disabled={!clientSignature || uploadingAgreement}
              className={`w-full p-2 rounded-md text-white ${clientSignature && !uploadingAgreement ? 'bg-blue-500 hover:bg-blue-600' : 'bg-gray-400 cursor-not-allowed'}`}
            >
              Accept Terms
            </button>
            {uploadingAgreement && (
              <div className='flex flex-row items-center justify-center gap-2'>
                <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
                <p>Uploading ACH Agreement...</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}